import React from "react";

export default function ConfirmDialog({ open, title = "Are you sure?", message, onCancel, onConfirm }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative w-[420px] max-w-[92vw] rounded-2xl bg-white shadow-xl">
        <div className="px-6 pt-5">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          {message ? <p className="mt-1 text-sm text-gray-600">{message}</p> : null}
        </div>
        <div className="mt-5 flex items-center justify-end gap-3 border-t px-6 py-4">
          <button
            onClick={onCancel}
            className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
